
















































import { Vue, Component, Prop } from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
import LayoutContent from '@/components/LayoutContent.vue';
import numberFormat from '@/libs/numberFormat';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import hasPermission from '@/libs/permission';

@Component({
  components: {
    LayoutContent,
    Loader,
    Button,
    AddIcon,
  },
  methods: {
    numberFormat,
    hasPermission,
  },
})
export default class BalanceBox extends Vue {
  numberFormat!: (val: number) => string;

  @Prop({ type: String, default: 'Merchant Balance Summary' }) title!: string;
  @Prop(Number) balance!: number;
  @Prop(String) merchantId!: string;
  @Prop(Boolean) loading!: boolean;

  hasPermission!: (val: string | string[]) => boolean;
}
